import { z } from 'zod';
/** Canonical timestamp for every public TechPOS API response: UTC with millisecond precision. */
export const UtcDateTimeSchema = z.iso.datetime({ precision: 3 });
/** Accepted request timestamp when callers need to express an explicit non-UTC offset. */
export const OffsetDateTimeInputSchema = z.iso.datetime({ offset: true });
